/* eslint-disable no-lone-blocks */
import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import {stopLoading, startLoadding} from '../../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {ENV} from '../../../../../Utils/_helpers/EnvHelper'

const API_URL = ENV().REACT_APP_API_URL
const initialState = {
  AdminoptoutList: [],
}

const RouteUrl = {
  GetAllData: 'admin/optoutList',
  GetData: '',
  EditData: 'admin/optoutList',
  DeleteData: 'admin/optoutList/deleteOpt',
  CreateData: 'admin/optoutList',
  setdefault: 'admin/optoutList/setDefault ',
}
const thunkName = {
  GetAllData: 'admin-optoutList-GetALLDATA',
  GetData: 'admin-optoutList-GetDataById',
  EditData: 'admin-optoutList-EditData',
  DeleteData: 'admin-optoutList-Delete',
  CreateData: 'admin-optoutList-Create',
  setdefault: 'admin-optoutList-setDefault ',
}

export const GetAllData: any = createAsyncThunk(thunkName.GetAllData, async (data, thunkApi) => {
  const response = await axios.get(`${API_URL}${RouteUrl.GetAllData}`, {
    params: data,
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
  })
  thunkApi.dispatch(stopLoading())
  return response.data
})

export const DeleteData: any = createAsyncThunk(thunkName.DeleteData, async (data, thunkApi) => {
  const response = await axios.put(`${API_URL}${RouteUrl.DeleteData}`, data, {
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
  })
  {
    response.data?.status == true && toast.success(response.data.message)
  }

  thunkApi.dispatch(GetAllData())
})
export const CreateData: any = createAsyncThunk(
  thunkName.CreateData,
  async (data: any, thunkApi) => {
    thunkApi.dispatch(startLoadding())
    const response = await axios.post(`${API_URL}${RouteUrl.CreateData}`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    {
      response.data?.status == true && toast.success(response.data.message)
    }
    thunkApi.dispatch(stopLoading())
    thunkApi.dispatch(GetAllData())
  }
)
export const UpdateData: any = createAsyncThunk(thunkName.EditData, async (data: any, thunkApi) => {
  thunkApi.dispatch(startLoadding())
  const response = await axios.post(`${API_URL}${RouteUrl.CreateData}/${data?.id}`, data.data, {
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
  })
  {
    response.data?.status == true && toast.success(response.data.message)
  }
  thunkApi.dispatch(stopLoading())
  thunkApi.dispatch(GetAllData())
})

const AdminOptoutList = createSlice({
  name: 'AdminOptoutList',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(GetAllData.fulfilled, (state, action) => {
      return {...state, AdminoptoutList: action?.payload}
    })
  },
})

export default AdminOptoutList.reducer
